import React, { FC } from 'react';
import { Text, Grid, Box } from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { useGetRestaurants } from '../../services/restaurant/restaurant.service';
import { RestaurantsNearbyScrollArea } from '../Home/styles';
import RestaurantCard from '../Home/RestaurantCard';
import SearchBar from '../Home/SearchBar';

const RestaurentCategoryList: FC = () => {
  const location = useLocation();
  const { data, isSuccess, isLoading, isFetching, isRefetchError, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useGetRestaurants({
      name: location.state.name,
    });

  const scrollHandler = async (e: any) => {
    const totalHeight = e.target.clientHeight + e.target.scrollTop;
    if (totalHeight >= e.target.scrollHeight - 50 && !isFetching && !isLoading && hasNextPage && !isRefetchError) {
      fetchNextPage();
    }
  };

  return (
    <>
      <SearchBar />
      <Box mt={16} px={8}>
        <Grid>
          <Grid.Col span={2} ta='left'>
            <Text fz='16px' pb='15px' fw={500} color={'#ffffff'}>
              {location.state.name}
            </Text>
          </Grid.Col>
        </Grid>
        <RestaurantsNearbyScrollArea onScroll={scrollHandler}>
          <Grid p={0} m={0}>
            {isSuccess && Array.isArray(data?.pages)
              ? data?.pages.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.data?.map((restaurant, index: number) => (
                      <Grid.Col xs={6} key={index}>
                        <RestaurantCard
                          type='regular'
                          id={restaurant.restaurant_id}
                          imageUrl={restaurant.image_url!}
                          name={restaurant.name}
                          averageRating={restaurant.rating.average_rating}
                          averageRatingCount={restaurant.rating.count}
                          openingTime={restaurant.business_hour.opening_time ?? ''}
                          closingTime={restaurant.business_hour.closing_time ?? ''}
                          schedule={restaurant.schedule ?? ''}
                          fullAddress={restaurant.full_address}
                          restaurantOpen={restaurant.is_restaurant_open}
                          backgroundImage={restaurant?.background_image_url ?? ''}
                        />
                      </Grid.Col>
                    ))}
                  </React.Fragment>
                ))
              : null}
            {isLoading || isFetchingNextPage
              ? Array(2)
                  .fill(0)
                  .map((d, index) => (
                    <Grid.Col xs={6} key={index}>
                      <RestaurantCard type='loading' />
                    </Grid.Col>
                  ))
              : null}
          </Grid>
        </RestaurantsNearbyScrollArea>
      </Box>
    </>
  );
};

export default RestaurentCategoryList;
